import React, { Component } from "react";
import NewGeofence from "./NewGeofence";
import {Map, Polygon, GoogleApiWrapper} from 'google-maps-react';
import Select from 'react-select';
import { invokeApig } from '../../libs/awsLib';
import config from "../../config";
import "./Geofence.css";

export class Geofence extends Component {
  constructor(props) {
    super(props);
    this.defaultOptions = [];
    this.state = {
      isLoading: true,
      removeSelected: true,
      disabled: false,
      stayOpen: false,
      value: null,
      options: this.defaultOptions,
      events: null,
      zone: []
    };
  }

  async componentDidMount() {
	  this.showZones();
  }

  getZones() {
    return invokeApig({
      path: "/zone/find",
      method: "POST",
      body: {
        "page": 0,
        "size": 10
      }
    });
  }

  getZone(id) {
    return invokeApig({
    	path: `/zone/${id}`,
        method: "GET"
    });
  }

  async showZones() {
	const options = [];
    try {
      this.setState({ options: [] });
      const result = await this.getZones();
      result.map((zone) => {
    	  options.push({
    		  id: zone.id,
    		  label: zone.name
    	  });
    	  return null;
      });
    } catch (e) {
      alert(e);
    }
    this.setState({ options: options, isLoading: false });
  }
  
  handleSelectChange = async (value) => {
    this.setState({ value, zone: [] });
	if (value) {
	  var zone = await this.getZone(value.id);
	  var finalZone = { id: zone.id, name: zone.name }
	  var zones = [];
	  const { google } = this.props;
	  const newBounds = new google.maps.LatLngBounds();
	  const map = this.map ? this.map.map : {};
	  zone.geometry.coordinates.map((list) => {
		  var subzones = [];
		  list.map((point) => {
		    point = { lat: point[1], lng: point[0] };
		    subzones.push(point);
		    newBounds.extend(point);
		    return '';
		  });
		  zones.push(subzones);
		  return '';
	  });
	  map.fitBounds(newBounds);
	  finalZone.points = zones;
	  this.setState({ zone: finalZone });
	} else { //eliminar todo
	  this.setState({ zone: [] });
	}
  }

  renderZones = () => {
	  const paths = this.state.zone.points ? this.state.zone.points : [];
	  if (paths.length) {
		  if (paths.length > 1) {
			  for(var i=1; i<paths.length; i++) {
				  paths[i] = paths[i].reverse();
			  }
			  return <Polygon key={Date.now()} paths={ paths } visible={true} />
		  } else {
			  return <Polygon key={Date.now()} paths={paths[0]} visible={true} />
		  }
	  }
//	  return (
//	    paths.map((val) => {
//	      return <Polygon key={Date.now()} paths={val} visible={true} />
//	    })
//      );
  }

  render() {
    const style = {
	  width: '100%',
	  height: window.innerHeight + 'px'
	}
    const initialCenter = {
      lat: 0,
      lng: 0
    }
    
    const { disabled, stayOpen, value, options } = this.state;
    return (
      <div>
	    <div className="select-container">
	      <Select
	      	className="zoneSelect"
			closeOnSelect={!stayOpen}
			disabled={disabled}
	        multi={false}
			onChange={this.handleSelectChange}
	    	options={options}
	        placeholder="Click para ver opciones"
	        removeSelected={this.state.removeSelected}
	        valueKey="id"
	        labelKey="label"
			value={value}
	      />
	      <NewGeofence {...this.props}/>
	    </div>
	    <Map
	      google={this.props.google}
	      style={style}
	      initialCenter={initialCenter}
	      centerAroundCurrentLocation={true}
	      ref={(map) => this.map = map}
	      zoom={10}>
		    { this.renderZones() }
		</Map>
	  </div>
    );
  }
}

export default GoogleApiWrapper({
	  apiKey: (config.API_GOOGLE_MAPS)
})(Geofence)


// WEBPACK FOOTER //
// ./src/containers/geofence/Geofence.js